import { getRequest } from '../../services/api';

import type { UserSnappyGiftsResponse } from './types';

export async function fetchUserSnappyGifts() {
  return getRequest<UserSnappyGiftsResponse>('/v2/user/snappy-gifts');
}
